const Data = [
  {
    name: "Zalavadiya Dishil",
    position: "Chief Executive Officer, LiGHT",
    imageUrl: "/assets/images/members/GB26/Dishil.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: "dishil.zalavadiya@gyws.org"
  }
];

export default Data;